// extracted by mini-css-extract-plugin
export var footer = "_mi-5";
export var fulfillmentInput = "_mi-0";
export var shipDateInput = "_mi-1";
export var shipmentModal = "_mi-2";
export var shipmentModalContent = "_mi-3";
export var tableContainer = "_mi-4";